module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/vi/4-78eeb713fef425c1adc440b2aa65e06a.jpg";